import {useMutation} from '@tanstack/react-query';
import {
  setAnalysisProcessingInCache,
  restoreContentSubmissionsCache,
  CacheSnapshot,
} from '@/utils/cache-updaters/contentSubmissions';
import contentSubmissionVersionUpdaters from '@/api/updaters/contentSubmissionVersion';

interface UseStartContentSubmissionAnalysisMutationParams {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

function useStartContentSubmissionAnalysisMutation({
  onSuccess,
  onError,
}: UseStartContentSubmissionAnalysisMutationParams = {}) {
  return useMutation({
    mutationFn: async (contentSubmissionVersionId: string) => {
      return contentSubmissionVersionUpdaters.startAnalysis(
        contentSubmissionVersionId
      );
    },
    onMutate: async (contentSubmissionVersionId: string) => {
      const snapshots = setAnalysisProcessingInCache(
        contentSubmissionVersionId
      );
      return {snapshots};
    },
    onError: (
      error: Error,
      _variables: string,
      context?: {snapshots: CacheSnapshot[]}
    ) => {
      if (context?.snapshots) {
        restoreContentSubmissionsCache(context.snapshots);
      }
      onError?.(error);
    },
    onSuccess: () => {
      onSuccess?.();
    },
  });
}

export default useStartContentSubmissionAnalysisMutation;
